import {
  createUserWithEmailAndPassword,
  deleteUser,
  getAuth,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db, firebaseConfig } from "./firebase";
import { initializeApp } from "firebase/app";
import { writeAuditLog } from "./audit";
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const adminUserApp = initializeApp(firebaseConfig, "admin-user-creation");
const adminUserAuth = getAuth(adminUserApp);

export const getManagedUsers = async () => {
  const snapshot = await getDocs(collection(db, "users"));

  return snapshot.docs
    .map((userDoc) => ({ id: userDoc.id, ...userDoc.data() }))
    .sort((first, second) =>
      String(first.email || "").localeCompare(String(second.email || ""))
    );
};

export const createManagedUser = async ({ email, password, role }, actor) => {
  let credential;

  try {
    credential = await createUserWithEmailAndPassword(
      adminUserAuth,
      email.trim(),
      password
    );

    await setDoc(doc(db, "users", credential.user.uid), {
      uid: credential.user.uid,
      email: email.trim(),
      displayName: email.trim().split("@")[0],
      role,
    });

    await writeAuditLog({
      action: "CREATE_USER",
      entityType: "user",
      entityId: credential.user.uid,
      entityTitle: email.trim(),
      changes: { role },
      user: actor,
    }).catch((error) => {
      console.error("User creation audit write failed:", error);
    });

    await signOut(adminUserAuth);
    return credential.user;
  } catch (error) {
    if (credential?.user) {
      await deleteUser(credential.user).catch(() => {});
    }
    await signOut(adminUserAuth).catch(() => {});
    throw error;
  }
};

export const updateManagedUserRole = async (user, role, actor) => {
  const previousRole = user.role || "viewer";

  await updateDoc(doc(db, "users", user.id), { role });
  await writeAuditLog({
    action: "UPDATE_USER_ROLE",
    entityType: "user",
    entityId: user.id,
    entityTitle: user.email || user.id,
    changes: { from: previousRole, to: role },
    user: actor,
  }).catch((error) => {
    console.error("User role audit write failed:", error);
  });
};

export const sendManagedUserPasswordReset = async (user, actor) => {
  await sendPasswordResetEmail(adminUserAuth, user.email);
  await writeAuditLog({
    action: "SEND_PASSWORD_RESET",
    entityType: "user",
    entityId: user.id,
    entityTitle: user.email || user.id,
    user: actor,
  }).catch((error) => {
    console.error("Password reset audit write failed:", error);
  });
};

export const setManagedUserPassword = (user, password) =>
  httpsCallable(functions, "setManagedUserPassword")({
    userId: user.id,
    password,
  });
